import { DD_MM_YYYY } from "./dateHelper";
import { DateQtyInputField, ProductCheckInExpiryDateQty } from "src/types";

export function removeEmptyExpiryDates(dateQtyInputFields: DateQtyInputField[]): DateQtyInputField[] {
  return dateQtyInputFields.filter((dateQtyInputField) => !(dateQtyInputField.date === ""));
}

export function normaliseDateQtyInputField(dateQtyInputField: DateQtyInputField): ProductCheckInExpiryDateQty {
  const expiryDate = dateQtyInputField.date;
  const qty = parseFloat(dateQtyInputField.qty) || 0;

  return { expiryDate, receivedQty: qty };
}

export function hasExpiryDateTotalMismatch(
  expiryDateQuantities: ProductCheckInExpiryDateQty[] = [],
  totalQty: number
): boolean {
  if (expiryDateQuantities.length === 0) {
    return false;
  }

  const totalExpiryDatesQty = expiryDateQuantities.reduce((sum, expiryDateEntry) => {
    return sum + Number(expiryDateEntry.receivedQty);
  }, 0);

  return totalExpiryDatesQty !== totalQty;
}

export function hasDuplicateExpiryDates(expiryDateQuantities: ProductCheckInExpiryDateQty[]): boolean {
  const expiryDates = expiryDateQuantities.map(({ expiryDate }) => expiryDate);
  return expiryDates.length !== new Set(expiryDates).size;
}

export function formatExpiryDates(expiryDates: ProductCheckInExpiryDateQty[] = []) {
  return (
    expiryDates
      .map((dateEntry) => {
        return dateEntry.expiryDate
          ? `${DD_MM_YYYY.formatDate(new Date(dateEntry.expiryDate))} (Qty: ${dateEntry.receivedQty})`
          : undefined;
      })
      .join("\n\n") || ""
  );
}
